import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';
import { Link } from 'react-router-dom';

const titleStyle = css`
	${theme.typography.cardTitle}
	margin: 0;
	color: ${theme.colors.ink};
`;

/**
 * Makes the whole card open the record without nesting anything inside an anchor: the `::after`
 * stretches this single link over the card, so there is exactly one link in the accessibility tree
 * and one keyboard stop. Siblings that must stay clickable lift themselves above it with their own
 * stacking context.
 */
const titleLinkStyle = css`
	color: inherit;
	text-decoration: none;

	&::after {
		content: '';
		position: absolute;
		// same as top/left/right/bottom: 0, but more explicit for the sake of clarity
		inset: 0;
		border-radius: inherit;
	}
`;

type Props = {
	readonly to: string;
	readonly onClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
	readonly children: React.ReactNode;
};

/** The title of a list card, as the link stretched over the card. */
const SubjectCardTitle: React.FC<Props> = ({ to, onClick, children }) => {
	return (
		<p css={titleStyle}>
			<Link css={titleLinkStyle} to={to} onClick={onClick}>
				{children}
			</Link>
		</p>
	);
};

export default SubjectCardTitle;
